import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Outfit\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\"],\"variable\":\"--font-outfit\",\"display\":\"swap\"}],\"variableName\":\"outfit\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\"],\"variable\":\"--font-mono\",\"display\":\"swap\"}],\"variableName\":\"jetbrainsMono\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/buildhome/repo/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalMusicPlayer"] */ "/opt/buildhome/repo/src/components/GlobalMusicPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/buildhome/repo/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionProvider"] */ "/opt/buildhome/repo/src/components/MotionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NeuralBackground"] */ "/opt/buildhome/repo/src/components/NeuralBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProgress"] */ "/opt/buildhome/repo/src/components/ScrollProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MusicPlayerProvider"] */ "/opt/buildhome/repo/src/context/MusicPlayerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/opt/buildhome/repo/src/i18n/I18nProvider.tsx");
